// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2rHfL","consentsList":"PatientConsents_consentsList__sKZMU","consentsListEmpty":"PatientConsents_consentsListEmpty__vC1sW"};